import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a36b2084&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=a36b2084&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36b2084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a36b2084')) {
      api.createRecord('a36b2084', component.options)
    } else {
      api.reload('a36b2084', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a36b2084&scoped=true&", function () {
      api.rerender('a36b2084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoods/index.vue"
export default component.exports